import React, { useRef } from 'react';
import { AppHeader } from '../../components/shared/AppHeader';
import { AppFooter } from '../../components/shared/AppFooter';
import { CTAFooterSection } from './sections/CTAFooterSection';
import { ComparisonSection } from './sections/ComparisonSection';
import { FAQSection } from './sections/FAQSection';
import { HeroSection } from './sections/HeroSection';
import { HowItWorksSection } from './sections/HowItWorksSection';
import { OQueMudaSection } from './sections/OQueMudaSection';
import { PersonasSection } from './sections/PersonasSection';
import { PlansSection } from './sections/PlansSection';
import { StatsSection } from './sections/StatsSection';
import './Home.scss';

export default function Home() {
  const plansRef = useRef<HTMLElement>(null);

  const scrollToPlans = () => {
    plansRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="home-page">
      <AppHeader variant="dark" />
      <main>
        <HeroSection onScrollToPlans={scrollToPlans} />
        <StatsSection />
        <ComparisonSection onScrollToPlans={scrollToPlans} />
        <OQueMudaSection onScrollToPlans={scrollToPlans} />
        <PlansSection sectionRef={plansRef} />
        <HowItWorksSection onScrollToPlans={scrollToPlans} />
        <PersonasSection />
        <FAQSection />
        <CTAFooterSection />
      </main>
      <AppFooter variant="simple" />
    </div>
  );
}
